module.exports = __webpack_public_path__ + "static/media/scheme3.eef85a88.png";